module.exports = __webpack_public_path__ + "static/media/wcp_bar_fen_hoa.6e4b4e95.png";